import {
  datasetDetailPageSizes,
  datasetDetailsViewTypes,
} from "constants/defaultValues";
import { statusOptions } from "components/AdvancedSearch/const";
import { getParameter } from "helpers/Utils";
import {
  GET_LIST_DATASET_DETAIL,
  GET_LIST_DATASET_DETAIL_SUCCESS,
  DATASET_DETAIL_CHANGE_PAGE,
  DATASET_DETAIL_CHANGE_LIMIT,
  DATASET_DETAIL_TOGGLE_ONE,
  DATASET_DETAIL_TOGGLE_ALL,
  DATASET_DETAIL_DESELECT_ALL,
  FETCH_MODULE_CODE_REQUEST,
  FETCH_MODULE_CODE_SUCCESS,
  DATASET_DETAIL_CHANGE_FILTER_CONDITION,
  DATASET_DETAIL_OPEN_SMART_TAG_DRAWER,
  DATASET_DETAIL_CLOSE_SMART_TAG_DRAWER,
  DATASET_DETAIL_SELECT_SOURCE_ID,
  DATASET_UPDATE_ITEMS,
  DATASET_DETAIL_OPEN_ADVANCED_SEARCH_DRAWER,
  DATASET_DETAIL_CLOSE_ADVANCED_SEARCH_DRAWER,
  DATASET_DETAIL_CHANGE_ADVANCED_FILTER,
  DATASET_DETAIL_SET_CURRENT_DATASET_ID,
  DATASET_DETAIL_GET_DATA_BY_ADVANCED_SUCCESS,
  DATASET_DETAIL_GET_DATA_BY_ADVANCED,
  DATASET_DETAIL_CHANGE_ADVANCED_FILTER_CONDITION,
  DATASET_DETAIL_CLEAR_ADVANCED_FILTER_CONDITION,
  DATASET_DETAIL_UPDATE_ITEM_BY_STATUS_SUCCESS,
  DATASET_DETAIL_BULK_UPDATE_STATUS_REQUEST,
  DATASET_DETAIL_BULK_UPDATE_STATUS_SUCCESS,
  DATASET_DETAIL_BULK_UPDATE_STATUS_FAILURE,
  DATASET_DETAIL_CHANGE_VIEW_TYPE,
  DATASET_DETAIL_TOGGLE_IMPORT_DATA,
  DATASET_DETAIL_TOGGLE_EXPORT_DATA,
  DATASET_DETAIL_TOGGLE_ASSIGN_MEMBER,
  DATASET_DETAIL_ASSIGN_MEMBER_SUCCESS,
  DATASET_DETAIL_UNCHECK_IDS,
  DATASET_DETAIL_TOGGLE_UNASSIGN_MODAL,
  DATASET_DETAIL_UNASSIGN_MEMBER_SUCCESS,
  DATASET_DETAIL_TOGGLE_DELETE_MODAL,
  DATASET_DETAIL_CLEAR_DATASET_IDS,
  CLEAR_ADVANCED_SEARCH_PAGE_CONDITION,
  DATASET_DETAIL_CHANGE_COUNTS_PER_ROW,
  DATASET_DETAIL_GET_ALL_DATASETS_OF_PROJECT_SUCCESS,
  DATASET_DETAIL_GET_MATTRIX_PERMISSION_SUCCESS,
  DATASET_DETAIL_TOGGLE_AUTO_LABEL_DIALOG,
  DATASET_DETAIL_GET_TARGET_LABELS_SUCCESS,
  DATASET_DETAIL_AUTO_LABELS_REQUEST,
  DATASET_DETAIL_AUTO_LABELS_SUCCESS,
  DATASET_DETAIL_AUTO_LABELS_FAILURE,
  DATASET_DETAIL_HANDLE_RESET_PAGE_ADVANCED_FILTER,
  DATASET_DETAIL_CHANGE_FILTER,
  DATASET_DETAIL_CLEAR_WHEN_LEAVE,
  DATASET_DETAIL_SET_IS_ADVANCED_SEARCH,
} from "redux/actions";

const setImmutable = (obj, path, value) => {
  const keys = path.split(".");

  const clone = { ...obj };

  let current = clone;
  let original = obj;

  keys.forEach((key, index) => {
    if (index === keys.length - 1) {
      current[key] = value;
      return;
    }

    current[key] = {
      ...(original?.[key] || {}),
    };

    current = current[key];
    original = original?.[key];
  });

  return clone;
};

const upsertMany = (
  byId,
  items,
  idKey = "sourceId",
  objectLabelers,
  objectReviewers,
  isUnassign = false,
) => {
  const next = { ...byId };

  items.forEach((item) => {
    const id = item[idKey];
    next[id] = {
      ...next[id],
      ...((item?.labeler !== undefined || isUnassign) && {
        labeler: isUnassign
          ? null
          : (objectLabelers[item.labeler].label ?? "N/A"),
      }),
      ...((item?.reviewer !== undefined || isUnassign) && {
        reviewer: isUnassign
          ? null
          : (objectReviewers[item.reviewer].label ?? "N/A"),
      }),
      ...(isUnassign && { status: "new" }),
      ...(next[id].status === "new" && { status: "assigned" }),
    };
  });

  return next;
};

const cleanObject = (obj) => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (value !== undefined && value !== "") {
      acc[key] = value;
    }
    return acc;
  }, {});
};

const buildQueryKey = (obj) => {
  const cleaned = cleanObject(obj);
  return JSON.stringify(
    Object.keys(cleaned)
      .sort()
      .reduce((acc, key) => {
        acc[key] = cleaned[key];
        return acc;
      }, {}),
  );
};

const INIT_STATE = {
  entities: {
    items: {
      byId: {},
    },
  },
  queries: {
    field: {
      ...(getParameter("labeler") && { labeler: getParameter("labeler") }),
      ...(getParameter("reviewer") && { reviewer: getParameter("reviewer") }),
      ...(getParameter("status") && {
        status: getParameter("status"),
      }),
    },
  },
  ui: {
    currentQueryKey: {},
  },
  pagination: {
    pageSize: getParameter("limit") ?? datasetDetailPageSizes[0],
    totalPage: 0,
    totalItem: 0,
    currentPage: getParameter("page") ?? 1,
    countsPerRow: 8,
  },
  selection: {
    selectedIds: {},
  },
  datasetName: "",
  isLoading: false,
  projectRole: null,
  roleData: null,
  isOpenSmartTag: false,
  isOpenAdvancedSearchDrawer: false,
  sourceId: null,
  isAdvancedSearch: false,
  datasets: [],
  targetLabels: [],

  /** Advanced search */
  advancedFilters: {
    imageSize: {
      from: {
        value: "",
        unit: "MB",
      },
      to: {
        value: "",
        unit: "MB",
      },
    },
    datasetIds: getParameter("dataset")
      ? getParameter("dataset").split(",")
      : [],
    labelIds: [],
    labelExcludeIds: [],
    labelingSize: {
      from: "",
      to: "",
    },
    resolution: {
      condition: "larger than",
      width: "",
      height: "",
    },
    searchByText: "",
    status: !getParameter("status")
      ? statusOptions.map((item) => item.value)
      : getParameter("status").split(","),
    tagsInclude: [],
    tagsExclude: [],
    ...(getParameter("labeler") && {
      labeler: [getParameter("labeler")],
    }),
    ...(getParameter("reviewer") && {
      reviewer: [getParameter("reviewer")],
    }),
  },
  mattrixPermission: null,
  advancedFiltersApply: {},
  currentDatasetId: null,
  viewType: datasetDetailsViewTypes[0].value,
  isOpenImportDataDrawer: false,
  isOpenModalExportDataDrawer: false,
  isOpenAssignMemberDrawer: false,
  isOpenConfirmModalUnAssign: false,
  isOpenDeleteModal: false,
  isOpenAutoLabelDialog: false,
  isLoadingAutoLabels: false,
  isLoadingBulkStatus: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LIST_DATASET_DETAIL:
      return { ...state, isLoading: true };
    case GET_LIST_DATASET_DETAIL_SUCCESS: {
      const {
        datasetDetails,
        datasetName,
        pageSize,
        currentPage,
        dataset_id,
        totalPage,
        totalItem,
        queries,
      } = action.payload;

      // 1. upsert vào byId
      const newById = { ...state.entities.items.byId };

      datasetDetails.forEach((item) => {
        newById[item.source_id] = {
          ...newById[item.source_id],
          ...item,
        };
      });

      // 2. build queryKey
      const queryKey = buildQueryKey({
        dataset_id,
        currentPage,
        pageSize,
        ...queries,
      });

      return {
        ...state,
        isLoading: false,
        ui: {
          ...state.ui,
          currentQueryKey: queryKey,
        },

        entities: {
          ...state.entities,
          items: {
            ...state.entities.items,
            byId: newById,
          },
        },
        datasetName,
        queries: {
          ...state.queries,
          [queryKey]: {
            ids: datasetDetails.map((item) => item.source_id),
          },
        },
        pagination: {
          ...state.pagination,
          totalPage,
          totalItem,
        },
        currentDatasetId: dataset_id,
      };
    }
    case DATASET_DETAIL_CHANGE_PAGE:
      return {
        ...state,
        isLoading: true,
        pagination: {
          ...state.pagination,
          currentPage: action.payload.currentPage,
        },
      };
    case DATASET_DETAIL_CHANGE_LIMIT:
      return {
        ...state,
        isLoading: true,
        pagination: {
          ...state.pagination,
          pageSize: action.payload.limit,
          currentPage: 1,
        },
      };
    case DATASET_DETAIL_TOGGLE_ONE:
      const id = action.payload;
      const selected = { ...state.selection.selectedIds };

      if (selected[id]) {
        delete selected[id];
      } else {
        selected[id] = true;
      }

      return {
        ...state,
        selection: {
          ...state.selection,
          selectedIds: selected,
        },
      };
    case DATASET_DETAIL_TOGGLE_ALL:
      const { ids } = action.payload;

      const selectedIds = {
        ...state.selection.selectedIds,
      };

      ids.forEach((id) => {
        selectedIds[id] = true;
      });

      return {
        ...state,
        selection: {
          ...state.selection,
          selectedIds,
        },
      };
    case DATASET_DETAIL_DESELECT_ALL:
      const { idsDeleted } = action.payload;

      const selectedIdsDeleted = {
        ...state.selection.selectedIds,
      };

      idsDeleted.forEach((id) => {
        delete selectedIdsDeleted[id];
      });

      return {
        ...state,
        selection: {
          ...state.selection,
          selectedIds: selectedIdsDeleted,
        },
      };
    case FETCH_MODULE_CODE_REQUEST:
      return { ...state };
    case FETCH_MODULE_CODE_SUCCESS:
      const allowedModules = ["labeling", "customer", "point_issue"];
      const labelingModule = action.payload.data.filter((module) =>
        allowedModules.some((allow) => module.includes(allow)),
      );
      return {
        ...state,
        projectRole: action.payload.roleCode,
        roleData: labelingModule,
      };
    case DATASET_DETAIL_CHANGE_FILTER_CONDITION:
      return {
        ...state,
        pagination: { ...state.pagination, currentPage: 1 },
        isLoading: true,
        queries: {
          ...state.queries,
          field: { ...state.queries.field, ...action.payload },
        },
        advancedFilters: {
          ...state.advancedFilters,
          ...(action.payload.labeler === "" && { labeler: [] }),
          ...(action.payload.reviewer === "" && { reviewer: [] }),
          ...(action.payload.labeler === null && { labeler: [null] }),
          ...(action.payload.reviewer === null && { reviewer: [null] }),
          ...(action.payload.status === "" && { status: [] }),
        },
      };
    case DATASET_DETAIL_OPEN_SMART_TAG_DRAWER:
      return { ...state, isOpenSmartTag: true };
    case DATASET_DETAIL_CLOSE_SMART_TAG_DRAWER:
      return { ...state, isOpenSmartTag: false };
    case DATASET_DETAIL_SELECT_SOURCE_ID:
      return { ...state, sourceId: action.payload };
    case DATASET_UPDATE_ITEMS: {
      const sourceIds = action.payload.sourceIds;
      const tags = action.payload.tags;

      const newById = { ...state.entities.items.byId };

      sourceIds.forEach((item) => {
        newById[item] = {
          ...newById[item],
          tags,
        };
      });

      return {
        ...state,

        entities: {
          ...state.entities,

          items: {
            ...state.entities.items,
            byId: newById,
          },
        },
      };
    }
    case DATASET_DETAIL_OPEN_ADVANCED_SEARCH_DRAWER: {
      return { ...state, isOpenAdvancedSearchDrawer: true };
    }
    case DATASET_DETAIL_CLOSE_ADVANCED_SEARCH_DRAWER: {
      return { ...state, isOpenAdvancedSearchDrawer: false };
    }
    case DATASET_DETAIL_CHANGE_ADVANCED_FILTER: {
      const { path, value } = action.payload;
      const newState = setImmutable(state, path, value);
      return newState;
    }
    case DATASET_DETAIL_CHANGE_ADVANCED_FILTER_CONDITION: {
      const { path, value } = action.payload;
      const field = path.split(".")[1];
      const newState = setImmutable(state, path, value);
      return {
        ...newState,
        pagination: { ...newState.pagination, currentPage: 1 },
        queries: {
          ...state.queries,
          field: { ...state.queries.field, [field]: value[0] },
        },
      };
    }
    case DATASET_DETAIL_SET_CURRENT_DATASET_ID: {
      const id = action.payload;
      return {
        ...state,
        advancedFilters: { ...state.advancedFilters, datasetIds: [id] },
      };
    }
    case DATASET_DETAIL_GET_DATA_BY_ADVANCED: {
      return {
        ...state,
        isAdvancedSearch: true,
        isLoading: true,
      };
    }
    case DATASET_DETAIL_GET_DATA_BY_ADVANCED_SUCCESS: {
      const { datasetDetails, totalPage, totalItem, objFilter } =
        action.payload;

      // 1. upsert vào byId
      const newById = { ...state.entities.items.byId };

      datasetDetails.forEach((item) => {
        newById[item.source_id] = {
          ...newById[item.source_id],
          ...item,
        };
      });

      // 2. build queryKey
      const queryKey = buildQueryKey(objFilter);

      return {
        ...state,
        isLoading: false,
        ui: {
          ...state.ui,
          currentQueryKey: queryKey,
        },
        entities: {
          ...state.entities,
          items: {
            ...state.entities.items,
            byId: newById,
          },
        },
        queries: {
          ...state.queries,
          [queryKey]: {
            ids: datasetDetails.map((item) => item.source_id),
          },
        },
        pagination: {
          ...state.pagination,
          totalPage,
          totalItem,
        },
        advancedFiltersApply: objFilter,
      };
    }
    case DATASET_DETAIL_CLEAR_ADVANCED_FILTER_CONDITION: {
      return {
        ...state,
        isLoading: true,
        advancedFilters: {
          imageSize: {
            from: {
              value: "",
              unit: "MB",
            },
            to: {
              value: "",
              unit: "MB",
            },
          },
          datasetIds: [action.payload.dataset_id],
          labelIds: [],
          labelExcludeIds: [],
          labelingSize: {
            from: "",
            to: "",
          },
          resolution: {
            condition: "larger than",
            width: "",
            height: "",
          },
          searchByText: "",
          status: statusOptions.map((item) => item.value),
          tagsInclude: [],
          tagsExclude: [],
          labeler: null,
          reviewer: null,
        },
        queries: { ...state.queries, field: {} },
        pagination: { ...state.pagination, currentPage: 1 },
        isAdvancedSearch: false,
      };
    }
    case DATASET_DETAIL_UPDATE_ITEM_BY_STATUS_SUCCESS: {
      const item = action.payload;

      let nextQueries = state.queries;
      if (state.isAdvancedSearch) {
        if (!state.advancedFilters.status.includes(item.status)) {
          const queryKey = buildQueryKey(state.advancedFiltersApply);
          const currentQuery = state.queries[queryKey];
          nextQueries = {
            ...state.queries,
            [queryKey]: {
              ...currentQuery,
              ids: currentQuery.ids.filter((id) => id !== item.source_id),
            },
          };
        }
      } else {
        if (state.queries.field.status) {
          const queryKey = buildQueryKey({
            dataset_id: state.currentDatasetId,
            currentPage: state.pagination.currentPage,
            pageSize: state.pagination.pageSize,
            ...state.queries.field,
          });
          const currentQuery = state.queries[queryKey];
          nextQueries = {
            ...state.queries,
            [queryKey]: {
              ...currentQuery,
              ids: currentQuery.ids.filter((id) => id !== item.source_id),
            },
          };
        }
      }

      return {
        ...state,
        queries: nextQueries,
        isLoading: false,
        entities: {
          ...state.entities,
          items: {
            ...state.entities.items,
            byId: {
              ...state.entities.items.byId,
              [item.source_id]: {
                ...state.entities.items.byId[item.source_id],
                status: item.status,
              },
            },
          },
        },
      };
    }
    case DATASET_DETAIL_BULK_UPDATE_STATUS_REQUEST: {
      return { ...state, isLoadingBulkStatus: true };
    }
    case DATASET_DETAIL_BULK_UPDATE_STATUS_SUCCESS:
    case DATASET_DETAIL_BULK_UPDATE_STATUS_FAILURE: {
      return { ...state, isLoadingBulkStatus: false };
    }
    case DATASET_DETAIL_CHANGE_VIEW_TYPE: {
      return { ...state, viewType: action.payload };
    }
    case DATASET_DETAIL_TOGGLE_IMPORT_DATA: {
      return {
        ...state,
        isOpenImportDataDrawer: !state.isOpenImportDataDrawer,
      };
    }
    case DATASET_DETAIL_TOGGLE_EXPORT_DATA: {
      return {
        ...state,
        isOpenModalExportDataDrawer: !state.isOpenModalExportDataDrawer,
      };
    }
    case DATASET_DETAIL_TOGGLE_ASSIGN_MEMBER: {
      return {
        ...state,
        isOpenAssignMemberDrawer: !state.isOpenAssignMemberDrawer,
      };
    }
    case DATASET_DETAIL_ASSIGN_MEMBER_SUCCESS: {
      const items = action.payload.result;
      const { objectLabelers, objectReviewers } = action.payload;
      const ids = items.map((item) => item.sourceId);
      const labelerId = items[0].labeler;
      const reviewerId = items[0].reviewer;

      let nextQueries = state.queries;
      if (state.isAdvancedSearch) {
        if (
          state.advancedFilters.labeler &&
          !state.advancedFilters.labeler.includes(labelerId)
        ) {
          const queryKey = buildQueryKey(state.advancedFiltersApply);
          const currentQuery = state.queries[queryKey];
          nextQueries = {
            ...state.queries,
            [queryKey]: {
              ...currentQuery,
              ids: currentQuery.ids.filter((id) => !ids.includes(id)),
            },
          };
        }
        if (
          state.advancedFilters.reviewer &&
          !state.advancedFilters.reviewer.includes(reviewerId)
        ) {
          const queryKey = buildQueryKey(state.advancedFiltersApply);
          const currentQuery = state.queries[queryKey];
          nextQueries = {
            ...state.queries,
            [queryKey]: {
              ...currentQuery,
              ids: currentQuery.ids.filter((id) => !ids.includes(id)),
            },
          };
        }
        if (
          state.advancedFilters.status.includes("new") &&
          state.advancedFilters.status.length !== 8
        ) {
          const queryKey = buildQueryKey(state.advancedFiltersApply);
          const currentQuery = state.queries[queryKey];
          nextQueries = {
            ...state.queries,
            [queryKey]: {
              ...currentQuery,
              ids: currentQuery.ids.filter((id) => !ids.includes(id)),
            },
          };
        }
      } else {
        if (
          state.queries.field.labeler !== undefined &&
          state.queries.field.labeler !== labelerId
        ) {
          const queryKey = buildQueryKey({
            dataset_id: state.currentDatasetId,
            currentPage: state.pagination.currentPage,
            pageSize: state.pagination.pageSize,
            ...state.queries.field,
          });
          const currentQuery = state.queries[queryKey];
          nextQueries = {
            ...state.queries,
            [queryKey]: {
              ...currentQuery,
              ids: currentQuery.ids.filter((id) => !ids.includes(id)),
            },
          };
        }
        if (
          state.queries.field.reviewer !== undefined &&
          state.queries.field.reviewer !== reviewerId
        ) {
          const queryKey = buildQueryKey({
            dataset_id: state.currentDatasetId,
            currentPage: state.pagination.currentPage,
            pageSize: state.pagination.pageSize,
            ...state.queries.field,
          });
          const currentQuery = state.queries[queryKey];
          nextQueries = {
            ...state.queries,
            [queryKey]: {
              ...currentQuery,
              ids: currentQuery.ids.filter((id) => !ids.includes(id)),
            },
          };
        }
        if (state.queries.field.status === "new") {
          const queryKey = buildQueryKey({
            dataset_id: state.currentDatasetId,
            currentPage: state.pagination.currentPage,
            pageSize: state.pagination.pageSize,
            ...state.queries.field,
          });
          const currentQuery = state.queries[queryKey];
          nextQueries = {
            ...state.queries,
            [queryKey]: {
              ...currentQuery,
              ids: currentQuery.ids.filter((id) => !ids.includes(id)),
            },
          };
        }
      }

      return {
        ...state,
        queries: nextQueries,
        entities: {
          ...state.entities,

          items: {
            ...state.entities.items,

            byId: upsertMany(
              state.entities.items.byId,
              items,
              "sourceId",
              objectLabelers,
              objectReviewers,
            ),
          },
        },
      };
    }
    case DATASET_DETAIL_UNCHECK_IDS: {
      return { ...state, selection: { ...state.selection, selectedIds: {} } };
    }
    case DATASET_DETAIL_TOGGLE_UNASSIGN_MODAL: {
      return {
        ...state,
        isOpenConfirmModalUnAssign: !state.isOpenConfirmModalUnAssign,
      };
    }
    case DATASET_DETAIL_UNASSIGN_MEMBER_SUCCESS: {
      const items = action.payload;
      const ids = items.map((item) => item.sourceId);

      let nextQueries = state.queries;
      if (state.isAdvancedSearch) {
        if (
          state.advancedFilters.labeler !== undefined ||
          state.advancedFilters.reviewer !== undefined
        ) {
          const queryKey = buildQueryKey(state.advancedFiltersApply);
          const currentQuery = state.queries[queryKey];
          nextQueries = {
            ...state.queries,
            [queryKey]: {
              ...currentQuery,
              ids: currentQuery.ids.filter((id) => !ids.includes(id)),
            },
          };
        }
        if (
          state.advancedFilters.status.length === 1 &&
          state.advancedFilters.status.includes("assigned")
        ) {
          const queryKey = buildQueryKey(state.advancedFiltersApply);
          const currentQuery = state.queries[queryKey];
          nextQueries = {
            ...state.queries,
            [queryKey]: {
              ...currentQuery,
              ids: currentQuery.ids.filter((id) => !ids.includes(id)),
            },
          };
        }
      } else {
        if (
          state.queries.field.labeler !== undefined ||
          state.queries.field.reviewer !== undefined
        ) {
          const queryKey = buildQueryKey({
            dataset_id: state.currentDatasetId,
            currentPage: state.pagination.currentPage,
            pageSize: state.pagination.pageSize,
            ...state.queries.field,
          });
          const currentQuery = state.queries[queryKey];
          nextQueries = {
            ...state.queries,
            [queryKey]: {
              ...currentQuery,
              ids: currentQuery.ids.filter((id) => !ids.includes(id)),
            },
          };
        }
        if (state.queries.field.status) {
          const queryKey = buildQueryKey({
            dataset_id: state.currentDatasetId,
            currentPage: state.pagination.currentPage,
            pageSize: state.pagination.pageSize,
            ...state.queries.field,
          });
          const currentQuery = state.queries[queryKey];
          nextQueries = {
            ...state.queries,
            [queryKey]: {
              ...currentQuery,
              ids: currentQuery.ids.filter((id) => !ids.includes(id)),
            },
          };
        }
      }

      return {
        ...state,
        queries: nextQueries,
        entities: {
          ...state.entities,
          items: {
            ...state.entities.items,

            byId: upsertMany(
              state.entities.items.byId,
              items,
              "sourceId",
              {},
              {},
              true,
            ),
          },
        },
      };
    }
    case DATASET_DETAIL_TOGGLE_DELETE_MODAL: {
      return {
        ...state,
        isOpenDeleteModal: !state.isOpenDeleteModal,
      };
    }
    case DATASET_DETAIL_CLEAR_DATASET_IDS: {
      return {
        ...state,
        advancedFilters: { ...state.advancedFilters, datasetIds: [] },
      };
    }
    case CLEAR_ADVANCED_SEARCH_PAGE_CONDITION: {
      return {
        ...state,
        advancedFilters: {
          ...state.advancedFilters,
          imageSize: {
            from: {
              value: "",
              unit: "MB",
            },
            to: {
              value: "",
              unit: "MB",
            },
          },
          datasetIds: [],
          labelIds: [],
          labelExcludeIds: [],
          labelingSize: {
            from: "",
            to: "",
          },
          resolution: {
            condition: "larger than",
            width: "",
            height: "",
          },
          searchByText: "",
          status: statusOptions.map((item) => item.value),
          tagsInclude: [],
          tagsExclude: [],
          labeler: null,
          reviewer: null,
        },
        queries: { ...state.queries, field: {} },
        pagination: { ...state.pagination, currentPage: 1 },
        isAdvancedSearch: true,
        isLoading: true,
      };
    }
    case DATASET_DETAIL_CHANGE_COUNTS_PER_ROW: {
      return {
        ...state,
        pagination: { ...state.pagination, countsPerRow: action.payload },
      };
    }
    case DATASET_DETAIL_GET_ALL_DATASETS_OF_PROJECT_SUCCESS: {
      return {
        ...state,
        datasets: action.payload,
      };
    }
    case DATASET_DETAIL_GET_MATTRIX_PERMISSION_SUCCESS: {
      return { ...state, mattrixPermission: action.payload };
    }
    case DATASET_DETAIL_TOGGLE_AUTO_LABEL_DIALOG: {
      return { ...state, isOpenAutoLabelDialog: !state.isOpenAutoLabelDialog };
    }
    case DATASET_DETAIL_GET_TARGET_LABELS_SUCCESS: {
      return { ...state, targetLabels: action.payload };
    }
    case DATASET_DETAIL_AUTO_LABELS_REQUEST: {
      return { ...state, isLoadingAutoLabels: true };
    }
    case DATASET_DETAIL_AUTO_LABELS_SUCCESS: {
      return { ...state, isLoadingAutoLabels: false };
    }
    case DATASET_DETAIL_AUTO_LABELS_FAILURE: {
      return { ...state, isLoadingAutoLabels: false };
    }
    case DATASET_DETAIL_HANDLE_RESET_PAGE_ADVANCED_FILTER: {
      return { ...state, pagination: { ...state.pagination, currentPage: 1 } };
    }
    case DATASET_DETAIL_CHANGE_FILTER: {
      const {
        page,
        limit,
        labeler,
        reviewer,
        status,
        datasetId,
        isAdvancedSearch,
        dataset,
      } = action.payload;
      return {
        ...state,
        pagination: {
          ...state.pagination,
          currentPage: page ?? 1,
          pageSize: limit ?? datasetDetailPageSizes[0],
        },
        isAdvancedSearch,
        queries: {
          ...state.queries,
          field: {
            ...state.queries.field,
            ...(typeof labeler !== "object" ? { labeler } : { labeler: "" }),
            ...(typeof reviewer !== "object" ? { reviewer } : { reviewer: "" }),
            ...(status ? { status: status.split(",") } : { status: [] }),
            ...(datasetId && { dataset_id: datasetId }),
          },
        },
        advancedFilters: {
          ...state.advancedFilters,
          ...(typeof labeler !== "object"
            ? { labeler: [labeler] }
            : { labeler: [] }),
          ...(typeof reviewer !== "object"
            ? { reviewer: [reviewer] }
            : { reviewer: [] }),
          ...(status ? { status: status.split(",") } : { status: [] }),
          ...(dataset
            ? { datasetIds: dataset.split(",") }
            : { datasetIds: [] }),
        },
      };
    }
    case DATASET_DETAIL_CLEAR_WHEN_LEAVE: {
      return {
        ...state,
        advancedFilters: {
          ...state.advancedFilters,
          imageSize: {
            from: {
              value: "",
              unit: "MB",
            },
            to: {
              value: "",
              unit: "MB",
            },
          },
          datasetIds: [],
          labelIds: [],
          labelExcludeIds: [],
          labelingSize: {
            from: "",
            to: "",
          },
          resolution: {
            condition: "larger than",
            width: "",
            height: "",
          },
          searchByText: "",
          status: [],
          tagsInclude: [],
          tagsExclude: [],
          labeler: null,
          reviewer: null,
        },
        queries: { ...state.queries, field: {} },
        pagination: { ...state.pagination, currentPage: 1 },
        isAdvancedSearch: false,
        isLoading: false,
        isOpenAdvancedSearchDrawer: false,
      };
    }
    case DATASET_DETAIL_SET_IS_ADVANCED_SEARCH: {
      return { ...state, isAdvancedSearch: true };
    }
    default:
      return { ...state };
  }
};
